<template>
  <MultibarChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import MultibarChart from '@/components/cards/models/MultibarChart';
import { mapActions, mapGetters } from 'vuex';
import EventBus from '@/utils/event-bus';

export default {
  name: 'GroupMultibarChart',
  components: {
    MultibarChart,
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: [],
      classifiedPercentage: 0,
      filter: {},
    };
  },
  computed: {
    ...mapGetters('dashboard', ['activeDashboardFilters', 'activeGlobalFilter']),
    series() {
      const filteredGroups = this.activeGlobalFilter?.names?.value || this.filter?.names?.value;

      if (filteredGroups) {
        const filteredData = this.rawSeries.all?.filter(item => filteredGroups.includes(item.name)) || [];

        return {
          ...this.rawSeries,
          all: [...filteredData],
        };
      }

      return this.rawSeries;
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getWarroomService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getWarroomService({
        itemId: this.itemId,
        servicePath: 'monitoringMultibar',
        serviceParams: {
          type: 'names',
        },
      })
        .then(response => {
          this.rawSeries = response.data || {};
          this.requestStatus = 'success';

          if (this.$attrs.filter) {
            this.filter = this.$attrs.filter;
          }

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>

<style scoped>
</style>
